export default __webpack_public_path__ + "static/media/Formatic.50ecf780.svg";